import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { SECTIONS } from "components/FormerEditor/utils";
import FieldController from "components/FieldController";
import FeatureGroupOrderSettings from "./FeatureGroupOrderSettings";
import { useFeatureGroups } from "utils/selectors";
import { BUTTON_TAGS, UI_THEME } from "utils/constants/ui";
import { useAppManifestSectionDestination } from "utils/hooks";
import CTA from "components/CTA";
import { useScrollToElement } from "utils/hooks/editor";

const FeatureComparisonBlock = (props) => {
  const featureGroups = useFeatureGroups();
  useScrollToElement(props.name);
  const hasFeatureGroups = featureGroups.length > 0;

  const rootPath = `${props.name}.data`;

  const destination = useAppManifestSectionDestination(SECTIONS.FEATURES);

  return (
    <Fragment>
      {hasFeatureGroups ? (
        <Fragment>
          <div className="ph3 pt3">
            <FieldController
              name="title"
              label="Title"
              key={`${rootPath}.title`}
              rootPath={rootPath}
              fieldKey="title"
            />
          </div>
          <div className="pt3">
            <FeatureGroupOrderSettings key={`${rootPath}.group`} />
          </div>
        </Fragment>
      ) : (
        <CTA
          customClasses={{
            container: "pb3 pt3 bb hairline-1",
            header: "f4 ph3 fw5",
            subheader: "f6 ph3 lh-copy",
            actionsWrapper: "flex flex-row z-1 pr3 justify-between"
          }}
          header="Feature groups"
          subheader="Add and group your product features for display on the feature comparison table."
          actions={[
            {
              copy: "Add",
              tag: BUTTON_TAGS.LINK,
              theme: UI_THEME.SLIM,
              href: destination
            }
          ]}
        />
      )}
    </Fragment>
  );
};

FeatureComparisonBlock.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};

export default FeatureComparisonBlock;
